import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../../../const/axios'

const pretty = (obj: any) => JSON.stringify(obj, null, 2)

const RatingAdminCertification: React.FC = () => {
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [certTournamentId, setCertTournamentId] = useState('')
  const [certStatus, setCertStatus] = useState('certified')
  const [certTier, setCertTier] = useState('local')
  const [certDifficulty, setCertDifficulty] = useState('D1')
  const [certNotes, setCertNotes] = useState('')

  const handleCertify = async () => {
    setMessage('')
    setError('')
    try {
      const res = await api.post(`/tournaments/${certTournamentId}/certify`, {
        status: certStatus,
        tier: certTier,
        difficultyClass: certDifficulty,
        notes: certNotes,
      })
      setMessage(`Sertifikat yeniləndi: ${pretty(res.data)}`)
    } catch (err: any) {
      setError(err?.response?.data || 'Sertifikat yenilənmədi.')
    }
  }

  const input = 'w-full border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40'

  return (
    <div className="min-h-screen bg-slate-50 pt-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-black text-slate-900">Tournament certification</h1>
          <Link to="/ratings/admin" className="text-sm text-blue-700 dark:text-indigo-300">Panel home</Link>
        </div>

        {message ? <pre className="text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 p-3 rounded-lg overflow-auto">{message}</pre> : null}
        {error ? <p className="text-sm text-red-600">{String(error)}</p> : null}

        <section className="bg-white dark:bg-gray-900 rounded-2xl border border-slate-100 shadow-sm p-4 space-y-3">
          <input className={input} placeholder="Tournament ID" value={certTournamentId} onChange={(e) => setCertTournamentId(e.target.value)} />
          <select className={input} value={certStatus} onChange={(e) => setCertStatus(e.target.value)}>
            <option value="certified">certified</option>
            <option value="rejected">rejected</option>
            <option value="draft">draft</option>
          </select>
          <select className={input} value={certTier} onChange={(e) => setCertTier(e.target.value)}>
            <option value="local">local</option>
            <option value="regional">regional</option>
            <option value="national">national</option>
          </select>
          <input className={input} placeholder="Difficulty (D1..D5)" value={certDifficulty} onChange={(e) => setCertDifficulty(e.target.value)} />
          <input className={input} placeholder="Qeyd" value={certNotes} onChange={(e) => setCertNotes(e.target.value)} />
          <button onClick={handleCertify} className="bg-slate-900 text-white px-3 py-2 rounded-lg text-sm font-semibold">Sertifikatla</button>
        </section>
      </div>
    </div>
  )
}

export default RatingAdminCertification
